window.SelectJobsForm = function ($scope, JobDetailsBus, $filter) {
    var self = this;
    var formName = "select-jobs-form";
    var _protected = BaseForm.call(self, formName, $scope);

    self.MAX_JOBS_ALLOWED_TO_APPLY = 10;
    self.jobs = [];
    self.viewJobs = [];
    self.numsOfJobs = 0;
    self.numsOfSelectedJobs = 0;
    self.numsOfSelectedJobsWithoutDisabled = 0;
    self.viewTrigger = false;
    self.translated_text = {
        'already_applied': $filter('translate')('Already Applied'),
        'apply_via_external_link_only': $filter('translate')('Apply Via External Link Only'),
        'open': $filter('translate')('Open'),
        'apply_via_job_post_only': $filter('translate')('Apply Via job Post Only'),
        'open_job_link_details_in_external_tab':  $filter('translate')('Open job link details in external tab'),
    };

    self.load = function (formData) {
        self.loading = true;
        self.userLatitude = formData && formData.userLatitude;
        self.userLongitude = formData && formData.userLongitude;

        const searchParams = formData?.searchParams;
        searchParams.size = 1000;
        searchParams['flow'] = 'CAREER_PORTAL';

        CareerPortalAPI.searchJobsForBrand(searchParams).then(function (jobs) {
            self.jobs = jobs.data.results;
            self.numsOfJobs = jobs.data.hits;
            prepareJobs();
        });
    }
    var prepareJobs = function () {
        if (self.jobs.length) {
            var jobsIds = _.pluck(self.jobs, 'id');
            var promises = [];
            for (var i = 0; i < jobsIds.length - 1; i = i + 100) {
                promises[i] = JobApplicationAPI.getJobsDetails(jobsIds.slice(i, i + 100), true, true)
            }
            $q.all(promises)
                .then(function (result) {
                    var jobsATS = [];
                    for (var i = 0; i < jobsIds.length - 1; i = i + 100) {
                        jobsATS = jobsATS.concat(result[i].jobs);
                    }
                    self.clearSelectedJobs();
                    self.jobs.forEach(function (job) {
                        // set default selected value
                        job.selected = false;

                        // set link for apply via job post
                        var jobPositionObj = {
                            'Position': job.position,
                            'custom_position': job.aliasPosition
                        };
                        job.applyLink = job.brand.slug + "/job/" + job.id + "-"+ $filter('userPosition')(jobPositionObj);
                        if (job.redirection_param){
                            job.applyLink = job.applyLink + "?redirect=" + self.jobs[0].redirection_param ;
                        }

                        // load Distance
                        if (job.locations && job.locations[0] && self.userLatitude && self.userLongitude) {
                            var distance = Utils.getDistanceFromLatLonInMiles(self.userLatitude, self.userLongitude, job.locations[0].latitude, job.locations[0].longitude);
                            if (distance > 100) {
                                job.distance = "Too Far - " + Math.round(distance) + " miles away";
                                job.tooFar = true;
                            } else {
                                job.distance = Math.round(distance) + " miles away";
                                job.tooFar = false;
                            }
                        }
                        // set ats url
                        var jobATSData = jobsATS.find(function (jobATS) {
                            return jobATS.id ===  job.id;
                        });

                        if (jobATSData && jobATSData.ats_url) {
                            var invalidATSURL = /harri.com/.test(jobATSData.ats_url) ;
                            if (!invalidATSURL) {
                                job.ats_url = jobATSData.ats_url;
                                job.disabled = true;
                            }
                        }

                        // set if already applied
                        if (jobATSData && jobATSData.already_applied) {
                            job.already_applied = jobATSData.already_applied;
                            job.disabled = true;
                        }

                        // set if not available for bulk apply
                        if (!job.is_available_for_bulk_apply) {
                            job.disabled = true;
                        }
                        self.loading = false;
                    });
                    self.viewJobs = self.jobs;
                    self.viewTrigger = !self.viewTrigger;
                    $scope.$digest();
                })
                .catch(function (err) {
                    console.error(err);
                });
        }
        self.loading = false;
    };

    self.assignHandlers = function (element) {
        element.find(".job-item-checkbox").on("click", function () {
            var jobId = $(this).attr('id');
            var jobSelected = $(this).is(':checked');
            self.onJobCheckboxChange(jobId, jobSelected);
            self.viewTrigger = !self.viewTrigger;
            $scope.$digest();
        });
    };

    self.save = function () {
        var defer = $q.defer();

        if (self.validator.validate() && self.numsOfSelectedJobsWithoutDisabled <= self.MAX_JOBS_ALLOWED_TO_APPLY) {
            var selectedJobs = self.jobs.filter(function (job) {
                if (job.selected) {
                    return (job.id);
                }
            });
            defer.resolve({
                "numsOfSelectedJobs": self.numsOfSelectedJobsWithoutDisabled,
                "selectedJobs": selectedJobs,
            });
        } else {
            defer.reject();
        }

        return defer.promise;

    };

    self.clearSelectedJobs = function () {
        self.viewJobs.forEach(function (job) {
            job.selected = false;
        });
        self.numsOfSelectedJobs = 0;
        self.numsOfSelectedJobsWithoutDisabled = 0;
    };

    self.loadDistance = function () {
        self.jobs.forEach(function (job) {
            if (job.locations && job.locations[0]) {
                if(self.userLatitude && self.userLongitude)  {
                    var distance = Utils.getDistanceFromLatLonInMiles(self.userLatitude, self.userLongitude, job.locations[0].latitude, job.locations[0].longitude);
                }
                if (distance > 100) {
                    job.distance = "Too Far - " + Math.round(distance) + " miles away";
                    job.tooFar = true;
                } else {
                    job.distance = Math.round(distance) + " miles away";
                    job.tooFar = false;
                }
            }
        });
    };

    self.onJobCheckboxChange = function (jobId, jobSelected) {
        var job = self.viewJobs.find(function (job) {
            return job.id === parseInt(jobId);
        });

        job.selected = jobSelected;
        if (job.selected) {
            self.numsOfSelectedJobs = self.numsOfSelectedJobs + 1;
            self.numsOfSelectedJobsWithoutDisabled = self.numsOfSelectedJobsWithoutDisabled + 1;
        } else {
            self.numsOfSelectedJobs = self.numsOfSelectedJobs - 1;
            self.numsOfSelectedJobsWithoutDisabled = self.numsOfSelectedJobsWithoutDisabled - 1;
        }
    };

    self.onSearchChanged = function () {
        var searchValue = "";
        searchValue = self.searchText.toLowerCase();
        var searchResult = self.jobs.filter(function (job) {
            var searchTerms = {
                locationName: job.locations[0] && job.locations[0].formatted_address.toLowerCase(),
                positionName: job.position && job.position.name.toLowerCase(),
                customPositionName: job.aliasPosition && job.aliasPosition.toLowerCase(),
                businessName: job.brand && job.brand.external_business_name && job.brand.external_business_name.toLowerCase(),
                brandName: job.brand && job.brand.name.toLowerCase(),
                storeNumber: job.brand && job.brand.store_number && job.brand.store_number.toLowerCase()
            };

            if (searchTerms.locationName && searchTerms.locationName.includes(searchValue)) {
                return true;
            }
            if (searchTerms.positionName && searchTerms.positionName.includes(searchValue)) {
                return true;
            }
            if (searchTerms.customPositionName && searchTerms.customPositionName.includes(searchValue)) {
                return true;
            }
            if (searchTerms.businessName && searchTerms.businessName.includes(searchValue)) {
                return true;
            }
            if (searchTerms.brandName && searchTerms.brandName.includes(searchValue)) {
                return true;
            }
            if (searchTerms.storeNumber && searchTerms.storeNumber.includes(searchValue)) {
                return true;
            }
        });
        self.viewJobs = searchResult;
        self.viewTrigger = !self.viewTrigger;
    };

    self.validator.validateCustom = function (field, optionsField, rule, showError, callback) {

        var name = field.attr("name");
        var value = self.validator.getFieldValue(field);

        switch (rule.name) {
            case "hasSelectedJobs":
                if (self.numsOfSelectedJobs == 0 && self.numsOfJobs !== 0) {
                    self.validator.validation[name].errors[rule.name] = true;
                    return false;
                }
                break;
        }
        return true;

    };
};
